/**
 * Variant picker of the post-ATC upsell popup (snippets/post-atc-upsell-variant-picker.liquid).
 *
 * Resolves the selected options to a variant and updates the popup in place:
 * the accept button's [data-atc-popup-accept] variant id (disabled when sold out),
 * the price (pre-rendered per variant in <template data-variant-price>), the image
 * and the selected-value labels. It is isolated from <variant-selects> / <product-info>,
 * so selecting an upsell option never re-renders or changes the main product.
 */
if (!customElements.get('post-atc-upsell-variants')) {
  customElements.define(
    'post-atc-upsell-variants',
    class PostAtcUpsellVariants extends HTMLElement {
      connectedCallback() {
        this.popup = this.closest('.post-atc-upsell');
        this.variants = JSON.parse(this.querySelector('script[data-variants]')?.textContent || '[]');
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        if (!event.target.matches('input[type="radio"]')) return;
        event.stopPropagation();

        const fieldset = event.target.closest('fieldset');
        const selectedValue = fieldset?.querySelector('[data-selected-value]');
        if (selectedValue) selectedValue.textContent = event.target.value;

        const variant = this.getSelectedVariant();
        this.updateAcceptButton(variant);
        if (!variant) return;

        this.updatePrice(variant);
        this.updateImage(variant);
      }

      getSelectedVariant() {
        const selectedOptions = [...this.querySelectorAll('fieldset[data-option-index]')].map(
          (fieldset) => fieldset.querySelector('input[type="radio"]:checked')?.value
        );

        return this.variants.find((variant) =>
          variant.options.every((option, index) => option === selectedOptions[index])
        );
      }

      updateAcceptButton(variant) {
        const acceptButton = this.popup?.querySelector('[data-atc-popup-accept]');
        if (!acceptButton) return;

        const isAvailable = Boolean(variant?.available);
        if (variant) {
          acceptButton.dataset.atcPopupAccept = variant.id;
          acceptButton.dataset.atcPopupPrice = variant.price;
        }
        acceptButton.disabled = !isAvailable;
        acceptButton.toggleAttribute('aria-disabled', !isAvailable);
      }

      updatePrice(variant) {
        const template = this.querySelector(`template[data-variant-price="${variant.id}"]`);
        const currentPrice = this.popup?.querySelector('.post-atc-upsell__price .price');
        const newPrice = template?.content.querySelector('.price');
        if (currentPrice && newPrice) currentPrice.replaceWith(newPrice.cloneNode(true));
      }

      updateImage(variant) {
        const image = this.popup?.querySelector('img.post-atc-upsell__image');
        if (!image || !variant.image) return;

        image.srcset = variant.image.srcset;
        image.src = variant.image.src;
        if (variant.image.alt) image.alt = variant.image.alt;
      }
    }
  );
}
